import Spinner, { SpinnerProps } from './Spinner'

type LoadingProps = SpinnerProps

const Loading = (props: LoadingProps) => <Spinner {...props} />

export default Loading
